import { apis } from '@doltech/core/lib/api/api.config';
import { apiCacheKeys, apiUrls } from '@doltech/core/lib/api/api.urls';
import { components } from '@doltech/pageManagement/dto';
import { ContentGroupEnum } from '@doltech/utils/lib/constants';
import { useQuery } from 'react-query';
import { apiPublicUrls } from '@doltech/core/lib/api/api.public-urls';

const fetchTrendingItemForSetup = async (query) => {
  query.contentGroup =
    query.contentGroup === ContentGroupEnum.ALL_GROUP ? undefined : query.contentGroup;
  const { data } = await apis.pageManagement.get(apiUrls.pageManagement.GET_TRENDING_ITEM, query);
  return data;
};

export const fetchHomeTrending = async (query = {}) => {
  const { data } = await apis.publicPageManagement.get(
    apiPublicUrls.pageManagement.GET_TRENDING_HOME,
    query
  );
  return data;
};

export const GetItemForSetupTrending = (params): any => {
  return useQuery(
    [apiCacheKeys.pageManagement.GET_TRENDING_ITEM_FOR_SETUP, params],
    () => fetchTrendingItemForSetup(params),
    {
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      refetchInterval: false,
      refetchOnMount: false,
      retry: false,
      keepPreviousData: false,
    }
  );
};

export const updateTrendingApi = (data) =>
  apis.pageManagement.put(apiUrls.pageManagement.UPDATE_TRENDING, data);

export const fetchIETrending = async () => {
  const { data } = await apis.publicPageManagement.get(
    apiPublicUrls.pageManagement.GET_TRENDING_BOOKS
  );
  return data;
};

export const getAllBooks = async (params) => {
  const query = { ...params };
  query.page -= 1;
  const { data } = await apis.pageManagement.get<components['schemas']['PageBookDTO']>(
    apiUrls.pageManagement.BOOKS,
    query
  );
  return data;
};

export const fetchBookTrending = async () => {
  const { data } = await apis.publicPageManagement.get<
    components['schemas']['BookForTrendingDTO'][]
  >(apiPublicUrls.pageManagement.GET_TRENDING_BOOKS);
  return data;
};
